import React from "react";
import { Modal, Fade, Box, IconButton } from "@material-ui/core";
import PropTypes from 'prop-types';
import { NewStyledModalStyles } from "./styles";
import Separator from "../Separator";
import CloseIcon from '@material-ui/icons/Close';


export const NewStyledModal = ({
  isModalOpen,
  handleModalClose,
  modalTitle,
  footerContent,
  children,
  showIconClose = true,
  topBorder = true,
  disableModalBorder = false,
}) => {

  const classes = NewStyledModalStyles();
  const boxStyleOptions = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  function handleModalOnClose() { handleModalClose() }

  return (
    <Modal
      className={classes.formModal}
      aria-labelledby={modalTitle}
      aria-describedby={modalTitle}
      open={isModalOpen}
      onClose={handleModalOnClose}
    >
      <Fade in={isModalOpen}>
        <Box sx={boxStyleOptions}>
          <div className={classes.titleWrapper}>
            <div>
              <h3 className={classes.modalTitle}>{modalTitle}</h3>
            </div>
            <IconButton className={classes.closeIcon} component="span" onClick={() => handleModalOnClose() }>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.separator}>
            <Separator />
          </div>
          <div className={classes.modalBody}>
            <div className={classes.modalBodyWrapper}>
              {children}
            </div>
          </div>
          <Box mt={3}>
            {footerContent()}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

NewStyledModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  modalTitle: PropTypes.string.isRequired,
  footerContent: PropTypes.func,
  children: PropTypes.any,
  showIconClose: PropTypes.bool,
  topBorder: PropTypes.bool,
  disableModalBorder: PropTypes.bool,
};
